export default {
  version: '1.1.1',
  releaseDate: 'October 28 2019'
}
